module.exports = __webpack_public_path__ + "media/images/svg-icon/basic-598c32475d29c8af558205b68fa9eee6.svg";